module.exports = __webpack_public_path__ + "src/ts/g.frame.modules/hands_view/assets/left_quest_hand.fbx";